<template>
    <div class="recruit-container">
        <div class="main-container">
            <h1>智能物联网研究中心招生通知</h1>
            <article>
                电子系智能物联网研究中心招收学术型/专业学位硕士，学术型博士。
            </article>
            <article>
                <div>请有意向攻读智能物联网研究中心研究生的同学将个人简历发至感兴趣的导师邮箱，导师研究方向可在下方导师列表中的导师主页查看。
                    <!-- 发送邮件时，请同时抄送一封邮件至IIoT官方邮箱<a href="mailto:iiot@acemap.cn">iiot@acemap.cn</a>。 -->
                </div>
                <p>简历需包含考研成绩（如果有），本科成绩单，以及申请的学位类型（学术型/专业学位硕士，学术型博士）。</p>
            </article>
            <article>
                <ul>
                    <li v-for="(item, index) in teacherList" :key="index">
                        <span style="display:inline-block; width: 100px;">{{ item.name }}</span>
                        <a :href="item.homePage">主页</a>
                        <a :href="`mailto:${item.mail}`">{{ item.mail }}</a>
                    </li>
                </ul>
            </article>
            <article>
                如有疑问，可发邮件咨询助管<a href="mailto:wujingyao@sjtu.edu.cn">wujingyao@sjtu.edu.cn</a>。
            </article>
            <!-- <article class="footer">
                <p>希望加入IIoT大家庭的同学，可以通过我们的报名二维码进行自己资料的申报！欢迎大家踊跃报名！</p>
                <img src="http://iiot.sjtu.edu.cn/images/career/joinus.jpg" alt="" srcset="" width="150px">
            </article> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            teacherList:[
                {
                    name: '王新兵',
                    homePage: 'https://iwct.sjtu.edu.cn/Personal/xwang8/index.html#',
                    mail: 'xwang8@sjtu.edu.cn'
                },
                {
                    name: '甘小莺',
                    homePage: 'https://iiot.sjtu.edu.cn/#/xygan',
                    mail: 'ganxiaoying@sjtu.edu.cn'
                },
                {
                    name: '傅洛伊',
                    homePage: 'https://www.cs.sjtu.edu.cn/~fu-ly/index.html',
                    mail: 'yiluofu@sjtu.edu.cn'
                },
                {
                    name: '俞晖',
                    homePage: 'https://ee.sjtu.edu.cn/FacultyDetail.aspx?id=38&infoid=66&flag=66',
                    mail: 'yuhui@sjtu.edu.cn'
                },
                {
                    name: '田晓华',
                    homePage: 'https://iiot.sjtu.edu.cn/#/xtian',
                    mail: 'xtian@sjtu.edu.cn'
                },
                {
                    name: '向立瑶',
                    homePage: 'http://xiangliyao.cn/',
                    mail: 'xiangliyao08@sjtu.edu.cn'
                },
                {
                    name: '赵世振',
                    homePage: 'https://jhc.sjtu.edu.cn/~shizhenzhao/',
                    mail: 'shizhenzhao@sjtu.edu.cn'
                },
                {
                    name: '江波',
                    homePage: 'https://jhc.sjtu.edu.cn/~bjiang/',
                    mail: 'bjiang@sjtu.edu.cn'
                },
                {
                    name: '丁家昕',
                    homePage: 'https://jhc.sjtu.edu.cn/~jiaxinding/',
                    mail: 'jiaxinding@sjtu.edu.cn'
                },
                {
                    name: '叶南阳',
                    homePage: 'https://jhc.sjtu.edu.cn/people/members/faculty/nanyang-ye.html',
                    mail: 'ynylincoln@sjtu.edu.cn'
                },
                {
                    name: '陈东尧',
                    homePage: 'https://chendy.tech/',
                    mail: 'chendy@sjtu.edu.cn'
                },
                {
                    name: '金梦',
                    homePage: 'https://jhc.sjtu.edu.cn/people/members/faculty/meng-jin.html',
                    mail: 'jinm@sjtu.edu.cn'
                },
                {
                    name: '林洲汉',
                    homePage: 'https://hantek.github.io/',
                    mail: 'hantek@sjtu.edu.cn'
                }
            ]
        }
    }    
}
</script>
<style lang="less" scoped>
.recruit-container {
    background: #ededed;
    min-height: calc(100vh - 255px);
    text-align: left;
    h1 {
        padding-top: 32px;
        font-size: 28px;
        font-weight: 900;
        margin-bottom: 36px;
    }
    article {
        margin-bottom: 24px;
        line-height: 24px;
        ul li {
            margin-bottom: 12px;
            span, a {
                margin-right: 12px
            }
        }
    }
    .footer {
        display: flex;
        align-items: center;
        margin: 0;
        padding-bottom: 64px;
        img {
            margin-left: 24px;
        }
    }
    a {
        color: #4a4d50;
        // text-decoration: none;
        font-weight: 800;
    }
}
</style>